import * as React from "react"

const RweEllipsis = (props) => (
    <svg
        id={"rwe_line"}
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M443.5 691C585.161 691 700 567.207 700 414.5S585.161 138 443.5 138 187 261.793 187 414.5 301.839 691 443.5 691Z"
            fill="#331083"
            fillOpacity={0.05}
        />
        <path
            d="M443.5 690C584.609 690 699 566.654 699 414.5S584.609 139 443.5 139C302.391 139 188 262.346 188 414.5S302.391 690 443.5 690Z"
            stroke="#DEDDE2"
            strokeWidth={2}
            strokeDasharray="3 3"
        />
        <path
            d="M423.5 671C565.161 671 680 556.161 680 414.5S565.161 158 423.5 158 167 272.839 167 414.5 281.839 671 423.5 671Z"
            fill="#331083"
            fillOpacity={0.05}
        />
        <path
            d="M423.5 670C564.609 670 679 555.609 679 414.5 679 273.391 564.609 159 423.5 159 282.391 159 168 273.391 168 414.5 168 555.609 282.391 670 423.5 670Z"
            stroke="#DEDDE2"
            strokeWidth={2}
            strokeDasharray="3 3"
        />
        <path
            d="M394.5 691C536.161 691 651 567.207 651 414.5S536.161 138 394.5 138 138 261.793 138 414.5 252.839 691 394.5 691Z"
            fill="#331083"
            fillOpacity={0.05}
        />
        <path
            d="M394.5 690C535.609 690 650 566.654 650 414.5S535.609 139 394.5 139C253.391 139 139 262.346 139 414.5S253.391 690 394.5 690Z"
            stroke="#DEDDE2"
            strokeWidth={2}
            strokeDasharray="3 3"
        />
    </svg>
)

export default RweEllipsis
